import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export default {
    namespaced: true,
    state: {
        viewMode: 1, //  1 = policy, 2 = confirmation
        loading: false,
        defaultToActiveField: true,
        price: null,
        useStaticModel: false,
        editMode: false,
        loadingModel: false,
        vueModel: null,
        initialVueModel: null,
        modalData: {
            title: null,
            content: null,
            buttons: []
        },
        showModal: false,
        responseData: null,
        basketFixed: false
    },
    getters,
    mutations,
    actions
};
